/*
 * @Author: xuejian3721
 * @Date: 2021-07-08 09:46:23
 * @LastEditors: zhenfangyu
 * @LastEditTime: 2025-07-08 20:28:03
 */
import axios from 'axios'
import { Message } from 'element-ui'
import qs from 'qs'
import { resCode } from '@/utils/res-types'
import { parseHashQuerys } from '@/utils/location'
import {getToken, getGrayscaleMark, getGrayscaleMarkValue, getGrayscaleMarkvalue} from '@/utils/auth'
const query = parseHashQuerys()
let baseURL = process.env.VUE_APP_baseURL
// pop切换api域名
if (query.pop == 1) {
  baseURL = process.env.VUE_APP_baseURL_POP
}

const instanceApi = axios.create({
  baseURL: '/api',
  withCredentials: false
})
const imApi = axios.create({
  baseURL: process.env.VUE_APP_CSproxyURL + '/imapi',
  withCredentials: false
})

const instance = axios.create({
  baseURL,
  withCredentials: false
})

const apiServices = [instance, instanceApi, imApi]

for (const instance of apiServices) {
  // 请求拦截器
  instance.interceptors.request.use(config => {
    // 判断是否需要转化formdata格式
    if (config.isFormdata || config.isFormData) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
      config.data = qs.stringify(config.data)
    }
    if (getToken() || query.customCode) {
      config.headers['kftoken'] = query.customCode || getToken()
    }
    if (config.isKFtoken) {
      config.headers['kftoken'] = config.isKFtoken
    }
    if (getGrayscaleMark() && getGrayscaleMarkValue()) {
      config.headers[getGrayscaleMark()] = getGrayscaleMarkValue() || getGrayscaleMarkvalue() || ''
    }
    return config
  })

  // 响应拦截器
  instance.interceptors.response.use(
    res => {
      const errCode = Number(res.data.code)
      if (
        !res.config.passError &&
        errCode != resCode.success &&
        errCode != resCode.dialogClosed &&
        errCode != resCode.incomingFailure &&
        res.data.msg
      ) {
        // 请求错误提示
        Message.error(res.data.msg)
      }
      return res.data
    },
    async err => {
      const errMsg = await getErrorMsg()
      Message.error(errMsg.msg)
      console.error(err)
      return Promise.reject(err.stack)
    }
  )
}

async function getErrorMsg() {
  const result = {}
  result.msg = '网络不给力，小九正在努力的为您寻找解决方案！'
  // 请求后端接口，查询是否异常
  // try {
  //   // 拼接对应环境接口地址
  //   let suffix = process.env.VUE_APP_DEPLOY_ENV
  //   if (process.env.NODE_ENV !== 'production') {
  //     if (suffix === 'development') {
  //       suffix = 'dev'
  //     }
  //     suffix += '.'
  //   } else {
  //     suffix = ''
  //   }
  //   const ret = await instance.get(`https://flag.${suffix}yyjzt.com/flag.json`, {
  //     timeout: 300,
  //     needFullResp: true
  //   })
  //   // 判断系统是否升级，优先获取后端展示信息
  //   if (ret && ret.data === '1') {
  //     // 修改文案为发版升级中
  //     result.msg = ret.msg || '系统升级中，请稍后再试'
  //   }
  // } catch (e) {
  //   console.log(e)
  // }
  return result
}

export { instance, instanceApi, imApi }
